/**
 * Aiká — Scroll & Load Animations
 * Sistema original, sem dependências externas.
 */
document.addEventListener('DOMContentLoaded', () => {
  // 1) Hero: revela assim que a página carrega (não espera scroll)
  document.querySelectorAll('.aika-hero').forEach((hero) => {
    requestAnimationFrame(() => {
      setTimeout(() => hero.classList.add('is-loaded'), 50);
    });
  });

  // 2) Todo o resto: revela quando entra na viewport
  const targets = document.querySelectorAll('[data-animate]');

  if (!('IntersectionObserver' in window) || !targets.length) {
    targets.forEach((el) => el.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.15,
      rootMargin: '0px 0px -10% 0px',
    }
  );

  targets.forEach((el) => observer.observe(el));
});
